import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { get } from 'lodash';
import { ApolloProvider } from '@apollo/react-hooks';
import client from '@api/graphql';
import {
  ManualAlertEvents,
  ManualAlertSummary,
  PreManualAlertDiagnostics,
  AlertDiagnostics,
} from './manualAlert';
import { ManualBase } from './base';

const AlertSummary = () => <ManualAlertSummary />;

// passing key to do a full remount
// to intiate a new jotai store to have clean state between multiple temp dashboards of same type
const AlertDiagnosticsDrilldown = (props) => {
  return <AlertDiagnostics key={get(props, 'match.params.id', -1)} {...props} />;
};

const Alert = () => {
  const match = useRouteMatch();
  const SummaryRedirect = () => <Redirect to={`${match.path}/manual/summary`} />;

  return (
    <ApolloProvider client={client}>
      <Switch>
        <Route path={`${match.path}/manual/summary`} component={ManualBase(AlertSummary)} />
        <Route path={`${match.path}/manual/events`} component={ManualBase(ManualAlertEvents)} />
        <Route path={`${match.path}/manual/diagnostics`} component={PreManualAlertDiagnostics} />
        <Route path={`${match.path}/manual`} render={SummaryRedirect} />
        <Route path={`${match.path}/diagnostics/:id`} render={AlertDiagnosticsDrilldown} />
      </Switch>
    </ApolloProvider>
  );
};

export default Alert;
